export default __webpack_public_path__ + "static/media/Entira Lufkin Logo-Color-for Web.5453c624.png";